import { render, staticRenderFns } from "./PartnerProfile.vue?vue&type=template&id=17bf65b6&scoped=true&"
import script from "./PartnerProfile.vue?vue&type=script&lang=ts&"
export * from "./PartnerProfile.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerProfile.vue?vue&type=style&index=0&id=17bf65b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf65b6",
  null
  
)

export default component.exports